import { AxiosResponse } from 'axios';
import WbHttpClient from '../../../services/wbhttpclient';

export default class CustomAtrservice extends WbHttpClient  {
  /**
   * Create custom Field Category
   * @param params
   */
   public createCustomCategory(params = {}): Promise<AxiosResponse> {
    return this.post('CustomCategoryField/addGovernanceCategory', params);
  }

  public searchteam(params = {}) : Promise<AxiosResponse> {
    return this.get('team/getAllTeamsAndBiz', params);
   
  }

  public fieldCategories(params = {}) : Promise<AxiosResponse> {
    return this.get('CustomCategoryField/searchCategories', params);
  }

  public categoryListingData(params = {}) : Promise<AxiosResponse> {
    return this.get('CustomCategoryField/getCatFields', params);
  }

  public submitNewCustomFields(params = {}) : Promise<AxiosResponse> {
    return this.post('CustomCategoryField/addGovernanceFields', params);
  }

  public deleteCategory(params = {}) : Promise<AxiosResponse> {
    return this.post('CustomCategoryField/deleteCategory', params);
  }

  public deleteCategoryField(params = {}) : Promise<AxiosResponse> {
    return this.post('CustomCategoryField/deleteCustomFields', params);
  }

  public archiveCategoryField(params = {}) : Promise<AxiosResponse> {
    return this.post('CustomCategoryField/archiveCustomFields', params);
  }

  public archiveCategory(params = {}) : Promise<AxiosResponse> {
    return this.post('CustomCategoryField/archiveCategory', params);
  }

  public getInitialDataCount(params = {}) : Promise<AxiosResponse> {
    return this.get('customCategoryField/initialDataCount', params);
  }

  public sortFields(params = {}) : Promise<AxiosResponse> {
    return this.post('CustomCategoryField/sortFields', params);
  }  

  public sortCategories(params = {}) : Promise<AxiosResponse> {
    return this.post('CustomCategoryField/sortCategories', params);
  } 

  public customEventTracking(params = {}) : Promise<AxiosResponse> {
    return this.get('customCategoryField/addCatFieldEvents', params);
  } 

  public getCustomFieldsByObject(params = {}) : Promise<AxiosResponse> {
    return this.get('goal/getCustomFieldsByObject', params);
  } 

}
